import React from 'react';
import { Table } from 'semantic-ui-react';
import {
  columnCreatedOn,
  columnDescription,
  columnName,
  columnNameLink,
  columnSize,
  columnTools,
  columnType,
  hasColumn,
} from '@/constants/fields';
import NameDescriptionRow from '@/components/table/NameDescriptionRow';
import { uploadEndpointDatasetAttachments } from '@/constants/urls';
import SimpleCell from '@/components/table/SimpleCell';
import DateCell from '@/components/table/DateCell';
import { downLoadableAttachmentIcon } from '../helper';
import AttachmentTypeFlag from './AttachmentTypeFlag';
import DatasetAttachmentManageCells from './DatasetAttachmentManageCells';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';
import FolderToolsMenu from './FolderToolsMenu';
import DatasetAttachmentDescriptionCell from './DatasetAttachmentDescriptionCell';

const FolderRow = ({
  category,
  code,
  columns,
  attachment: folder,
  upward,
}) => {
  const {
    canUpdate, isDownloading, isEditing, isLoading, isRoot,
  } = Selectors.useDatasetAttachmentRow({ category, code, attachment: folder });
  const onFolderClick = Events.useAttachmentFolderPush(category, { code });

  const {
    iconName, iconTitle, warning,
  } = downLoadableAttachmentIcon(folder, isDownloading);
  const cols = columns.map((column) => ([columnName, columnNameLink].includes(column) ? columnNameLink : column));

  return (
    <NameDescriptionRow
      asHref
      columns={cols.filter((column) => column !== columnDescription)}
      href={uploadEndpointDatasetAttachments(code, folder.id)}
      icon={iconName}
      loading={isDownloading}
      name={folder.name}
      nameMessageId={iconTitle}
      onClick={() => onFolderClick({ folder: { name: folder.name, id: folder.id } })}
      warning={canUpdate && warning}
    >
      {hasColumn(cols, columnDescription) && (
        <DatasetAttachmentDescriptionCell
          attachment={folder}
          canEdit={canUpdate}
          category={category}
          code={code}
        />
      )}
      {hasColumn(cols, columnType) && (
        <Table.Cell className="td-name">
          <AttachmentTypeFlag attachment={folder} />
        </Table.Cell>
      )}
      {hasColumn(cols, columnSize) && (<SimpleCell />)}
      <DatasetAttachmentManageCells
        attachment={folder}
        canManage={canUpdate && !isEditing}
        category={category}
        code={code}
        columns={cols}
        disabled={!isRoot}
        isLoading={isLoading}
        upward={upward}
      />
      {hasColumn(cols, columnCreatedOn) && <DateCell content={folder.created_at} />}
      {hasColumn(cols, columnTools) && (
        <Table.Cell collapsing className="aridhia-attachment-tools">
          <FolderToolsMenu
            folder={folder}
            category={category}
            code={code}
            upward
          />
        </Table.Cell>
      )}
    </NameDescriptionRow>
  );
};

export default FolderRow;
